import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getReferenceScenarioList } from 'src/redux/async/rfxManagement/rfpManagementAsync'

const initialState = {
  scenarioListLoader: false,
  scenarioListError: '',
  scenarioList: '',
}

export const customScenarioSlice = createSlice({
  name: 'custom-scenario',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getReferenceScenarioList.pending), (state) => {
      state.scenarioListLoader = true
      state.scenarioList = []
    })
    builder.addMatcher(isAnyOf(getReferenceScenarioList.fulfilled), (state, action) => {
      state.scenarioListLoader = false
      state.scenarioList = action.payload.data
      state.scenarioListError = ''
    })
    builder.addMatcher(isAnyOf(getReferenceScenarioList.rejected), (state, action) => {
      state.scenarioListLoader = false
      state.scenarioListError = action.payload
    })
  },
  reducers: {
    emptyScenarioListSlice: (state) => {
      state.scenarioListLoader = false
      state.scenarioListError = ''
      state.scenarioList = []
    },
  },
})

export const { emptyScenarioListSlice } = customScenarioSlice.actions

export default customScenarioSlice.reducer
